// extracted by mini-css-extract-plugin
module.exports = {"navHeaderGroup":"styles_navHeaderGroup__175jJ","navTitleRow":"styles_navTitleRow__2AekR","homeIcon":"styles_homeIcon__QpGi9","navSubtext":"styles_navSubtext__VVB9r"};